
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import Comments from './comments.vue';
import Axios from 'axios';
import { Message } from 'element-ui';
import config from '@/params/config';

@Component({
  components: { Comments }
})
export default class DocDetail extends Vue {
  get docSource() {
    let src = '';
    if (!!this.docId &&!!this.docUrl.result) {
      src = this.docUrl.result;
    } 

    const iframe =
      '<iframe src="' +
      src +
      '" frameborder="no" width="100%" height="600"></iframe>';

    return iframe;
  }

  loginSrc: string = '';
  // shareId: string = '';
  searchKey: string = '';
  treeProps: any = { children: 'children', label: 'label' };
  showCard: boolean = false;
  onCard: boolean = false;
  cardTime: any;
  vers: string = '';
  cataId: string = ''; // 大类id
  cataTitle: string = ''; // 大类标题
  catalog: any = [];
  docId: string = '';
  curNode: any = [];
  isEmpty: boolean = false;
  isHoverAndPraised: boolean = false; // 是否已点赞且hover状态
  // iframeLoading: boolean = false;
  processurl=config.processurl;

  @Getter category: any;
  @Getter doccatalog: any;
  @Getter docToken: any;
  @Getter docUrl: any;
  @Getter docDownload: any;
  @Getter docInfo: any;

  @Action('getCategory') getCategory: Function;
  @Action('getDoccatalog') getDoccatalog: Function;
  @Action('getDocToken') getDocToken: Function;
  @Action('getDocUrl') getDocUrl: Function;
  @Action('getDocDownload') getDocDownload: Function;
  @Action('getDocInfo') getDocInfo: Function;
  @Action('praiseDoc') praiseDoc: Function;
  @Action('cancelPraiseDoc') cancelPraiseDoc: Function;
  @Action('setDocViewed') setDocViewed: Function;

  mounted() {
    this.cataTitle = this.$route.query.title as string;
    // this.cataId = this.$route.query.id;
    this.getCategory({ groupName: 'DocumentCenter' }).then(() => {
      this.getCateId(this.cataTitle);
      if (!!this.cataId) {
        this.setDoccatalog(this.cataId);
      }
    });
  }
  // 设置文档大类
  setCategory(param: any) {
    if (!!param.ID) {
      this.$router.replace({
        path: this.$route.path,
        query: { id: param.ID, title: param.Title }
      });
      this.cataTitle = param.Title;
      this.catalog = [];
      this.setDoccatalog(param.ID);
    } else if (!!param.LinkUrl) {
      window.open(param.LinkUrl, '_blank');
    }
  }
  // 设置文档目录结构
  setDoccatalog(id: any) {
    this.vers = '';
    this.getDoccatalog({ nodeId: id })
      .then(() => {
        // 未处理特定版本
        let verid = '';
        if (!!this.$route.query.ver) {
          for (const item of this.doccatalog.infos) {
            if (
              this.$route.query.ver === item.label ||
              this.$route.query.ver === item.id
            ) {
              verid = item.id;
            }
          }
        }
        this.vers = verid || this.doccatalog.infos[0].id;
        this.handleVers(this.vers);
        if (!!this.$route.query.docid) {
          this.getDocById(this.$route.query.docid as string);
        } else this.getFirstnode(this.catalog);
      })
      .catch(() => {
        this.isEmpty = true;
      });
  }

  // 获取产品id
  getCateId(name: string) {
    if (!!this.$route.query.id) {
      this.cataId = this.$route.query.id as string;
    } else if (this.category.infos.length > 0) {
      for (const item of this.category.infos[0].children) {
        if (item.Title === name) {
          this.cataId = item.ID;
        }
      }
    }
  }

  // 获取目录第一个节点
  getFirstnode(list: any) {
    let obj = {};
    if (list[0].children && list[0].children.length > 0) {
      do {
        list = list[0].children;
      } while (list[0].children && list[0].children.length > 0);
      obj = list[0];
    } else {
      obj = list[0];
    }
    this.handleNodeClick(obj);
  }

  // 通过id获取文档
  getDocById(id: string) {
    this.$nextTick(function() {
      (this.$refs.cata as HTMLFormElement).setCurrentKey(id);
    });
    
    this.getDocToken();
    // this.shareId = '';
    this.docId = '';
    this.$nextTick(() => {
      this.docId = id;
      
    });
    this.curNode = [id];
    this.getDocInfo({ docId: id })
      .then(() => {
        this.isEmpty = false;
      })
      .catch((e: any) => {
        this.isEmpty = true;
      });
    this.getDocUrl({ fileId: id });
  }

  // 处理节点点击
  handleNodeClick(val: any) {
    if (!val.children || (val.children && val.children.length === 0)) {
      this.$router.replace({
        path: this.$route.path,
        query: {
          id: this.cataId,
          ver: this.vers,
          docid: val.id,
          title: this.cataTitle
        }
      });
    } else return false;
  }

  // 处理版本切换
  handleVers(val: any) {
    for (const item of this.doccatalog.infos) {
      if (item.id === val) {
        this.catalog = item.children;

        return;
      }
    }
  }

  // 处理弹窗
  handleCard(state: boolean) {
    let time = 0;
    if (this.showCard !== state) {
      if (!state) {
        time = 600;
      }
      this.cardTime = setTimeout(() => {
        this.showCard = state;
      }, time);
    } else {
      clearTimeout(this.cardTime);
    }
  }

  // 处理下载事件
  handleDownload() {
    this.getDocDownload({ fileId: this.docId }).then(() => {
      if (!!this.docDownload.result) {
        const btn: HTMLElement = document.querySelector(
          '#btnDown'
        ) as HTMLElement;
        setTimeout(() => {
          btn.click();
        }, 300);
        this.getDocInfo({ docId: this.docId })
          .then(() => {
            this.isEmpty = false;
          })
          .catch((e: any) => {
            this.isEmpty = true;
          });
      }
    });
  }

  // 处理点赞事件
  handlePraiseDoc() {
    const { IsPraised } = this.docInfo.result;
    const params = { docId: this.docId };
    if (IsPraised) {
      this.cancelPraiseDoc(params);
    } else {
      this.praiseDoc(params);
    }
  }

  // 监听路由docid变换
  @Watch('$route.query.docid', { immediate: true, deep: true })
  private changeRouter(route: any) {
    if (!!this.$route.query.docid) {
      this.setDocViewed({ docId: this.$route.query.docid });
      this.getDocById(this.$route.query.docid as any);
    }
  }
}
